import { render, staticRenderFns } from "./TicketReplacement.vue?vue&type=template&id=1dcf163e&"
import script from "./TicketReplacement.vue?vue&type=script&lang=js&"
export * from "./TicketReplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports